import { jsx as _jsx } from "react/jsx-runtime";
import * as WpBlocksApi from '@wordpress/blocks';
import CalendarIcon from '../Common/CalendarIcon';
import { connectionStatus } from '../../constants/leadinConfig';
import MeetingGutenbergPreview from './MeetingGutenbergPreview';
import MeetingSaveBlock from './MeetingSaveBlock';
import MeetingEdit from '../../shared/Meeting/MeetingEdit';
import ErrorHandler from '../../shared/Common/ErrorHandler';
import { __ } from '@wordpress/i18n';
import { isFullSiteEditor } from '../../utils/withMetaData';
import StylesheetErrorBondary from '../Common/StylesheetErrorBondary';
const ConnectionStatus = {
    Connected: 'Connected',
    NotConnected: 'NotConnected',
};
export default function registerMeetingBlock() {
    const editComponent = (props) => {
        const isPreview = props.attributes.preview;
        const isConnected = connectionStatus === ConnectionStatus.Connected;
        return (_jsx(StylesheetErrorBondary, { children: isPreview ? (_jsx(MeetingGutenbergPreview, {})) : isConnected ? (_jsx(MeetingEdit, { ...props, preview: true, origin: "gutenberg" })) : (_jsx(ErrorHandler, { status: 401 })) }));
    };
    // We do not support the full site editor: https://issues.hubspotcentral.com/browse/WP-1033
    if (!WpBlocksApi || isFullSiteEditor()) {
        return null;
    }
    WpBlocksApi.registerBlockType('leadin/hubspot-meeting-block', {
        title: __('Hubspot Meetings Scheduler', 'leadin'),
        description: __('Schedule meetings faster and forget the back-and-forth emails Your calendar stays full, and you stay productive', 'leadin'),
        icon: CalendarIcon,
        category: 'leadin-blocks',
        attributes: {
            url: {
                type: 'string',
                default: '',
            },
            preview: {
                type: 'boolean',
                default: false,
            },
        },
        example: {
            attributes: {
                preview: true,
            },
        },
        edit: editComponent,
        save: props => _jsx(MeetingSaveBlock, { ...props }),
    });
}
